<template>
  <Desktop v-if="$matchMedia.m" :points="points" />
  <Mobile v-else :points="points" />
</template>

<script>
import Desktop from './subcomponents/Desktop';
import Mobile from './subcomponents/Mobile';

export default {
  name: 'CareLevelResultTable',
  props: {},
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {
      points: [0, 12.5, 27, 47.5, 70, 90, 100],
    };
  },
};
</script>
